import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderTaxiRailyRecalculate from "./billings-order-taxi-raily-recalculate";
import BillingsOrderTaxiRailyRecalculateParams from "./billings-order-taxi-raily-recalculate-params";

const useRecalculateOrderTaxiRailyBilling = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderTaxiRailyRecalculate | null>(null);

  const load = async (
    params: BillingsOrderTaxiRailyRecalculateParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.recalculateOrderTaxiRailyBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useRecalculateOrderTaxiRailyBilling;
